<template>
    <main class="wrapper">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="官方小组" name="1"></el-tab-pane>
            <el-tab-pane label="用户创建小组" name="2"></el-tab-pane>
            <el-tab-pane label="最热" name="3"></el-tab-pane>
            <el-tab-pane label="最新" name="4"></el-tab-pane>
        </el-tabs>

        <div class="wrapper-search">
            <el-button size="small" type="primary" @click="addGroup" v-if="activeName == 1">新增</el-button>
            <el-form class="search-form" slot="left" label-width="85px" v-if="activeName == 2">
                <x-form
                    label="小组类型"
                    type="select"
                    :options="stateList"
                    v-model="searchModel.isRecommend"
                ></x-form>
                <el-button type="primary" @click="search">查询</el-button>
            </el-form>
        </div>

        <x-table
            :tableData="tableData"
            :tableHeaders="tableHeaders"
            :pageModel="pageModel"
            :fetchList="fetchList"
            border
            :total="total"
            :clickData="activeName > 2 ? clickData2 : clickData"
            @clickRight="clickRight"
            sortable
            @sort="sortTable"
            v-loading="loading"
        ></x-table>

        <detail ref="detail" :fetchList="fetchList"></detail>
        <user-detail
            ref="userDetail"
        ></user-detail>
        <recommend
            ref="recommend"
            :fetchList="fetchList"
        ></recommend>
    </main>
</template>

<script type="text/javascript">
import { groupList, delGroup, saveGroup, updateGroupOrder } from "@/api/group";
import {
    peopleList
} from '@/api/people'

import Detail from "./components/detail.vue";
import UserDetail from './components/userDetail.vue'
import Recommend from './components/recommend.vue'
import { formatDate, deepClone } from "@/utils/util";
import {Tag} from 'element-ui'

export default {
    data() {
        return {
            activeName: "1",
            tableData: [],
            searchModel: {
                isRecommend: '', 
            },
            stateList: [
                {
                    label: "全部",
                    value: '',
                },
                {
                    label: "公开",
                    value: 2,
                },
                {
                    label: "私密",
                    value: 1,
                }
            ],
            tableHeaders: [
                {
                    headerKey: "group_name",
                    headerName: "小组名",
                },
                {
                    headerKey: "time2",
                    headerName: "上下线时间",
                    width: 200,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.sign_in_online_time}/${node.sign_in_offline_time}`
                        );
                    },
                },
                {
                    headerKey: "time",
                    headerName: "开始时间/结束时间",
                    width: 200,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.sign_in_start_time}/${node.sign_in_end_time}`
                        );
                    },
                },
                {
                    headerKey: "day",
                    headerName: "已进行/总天数",
                    width: 100,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.star_day}/${node.all_day}`
                        );
                    },
                },
                {
                    headerKey: "all_user_count",
                    headerName: "今日加入人数/总加入人数",
                    width: 100,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.cur_day_join_user_count}/${node.all_user_count}`
                        );
                    },
                },
                {
                    headerKey: "sign_in_all_member",
                    headerName: "今日打卡人数/总打卡人数",
                    width: 100,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.sign_in_day_member}/${node.sign_in_all_member}`
                        );
                    },
                },
                {
                    headerKey: "all_comment_count",
                    headerName: "今日评论互动/总评论互动",
                    width: 100,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.cur_day_comment_count}/${node.all_comment_count}`
                        );
                    },
                },
                {
                    headerKey: "all_like_count",
                    headerName: "今日点赞互动/总点赞互动",
                    width: 100,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.cur_day_like_count}/${node.all_like_count}`
                        );
                    },
                },
                {
                    headerKey: "num",
                    headerName: "人数/次数",
                    width: 60,
                    render: (h, { node }) => {
                        return h(
                            "span",
                            `${node.all_user_count}/${node.all_sign_count}`
                        );
                    },
                },
                {
                    headerKey: "uid",
                    headerName: "创建人",
                    width: 60,
                    render: (h, {node}) => {
                        return h(
                            'span',
                            {
                                style: {
                                    color: '#409EFF',
                                    cursor: 'pointer'
                                },
                                on: {
                                    click: this.clickUser.bind(this, node)
                                }
                            },
                            node.uid
                        )
                    }
                },
                {
                    headerKey: "status",
                    headerName: "状态",
                    width: 60,
                    maps: {
                        0: "未上线",
                        1: "上线",
                        2: "开始",
                        3: "结束",
                        4: "下线",
                    },
                },
                {
                    headerKey: "is_recommend",
                    headerName: "小组类型",
                    maps: {
                        2: "公开",
                        1: "私密"
                    },
                },

                {
                    headerKey: "status",
                    headerName: "推荐状态",
                    render: (h, {node}) => {
                        let res = []
                        if (node.is_top == 2) {
                            res.push(h(
                                Tag,
                                {
                                    props: {
                                        size: 'mini',
                                    }
                                },
                                '置顶'
                            ))
                        }
                        if (node.is_careful_chosen == 2) {
                            res.push(h(
                                Tag,
                                {
                                    props: {
                                        size: 'mini',
                                    }
                                },
                                '精选'
                            ))
                        }
                        if (node.is_hottest == 2) {
                            res.push(h(
                                Tag,
                                {
                                    props: {
                                        size: 'mini',
                                        type: 'danger'
                                    }
                                },
                                '热门'
                            ))
                        }
                        if (node.is_newest == 2) {
                            res.push(h(
                                Tag,
                                {
                                    props: {
                                        size: 'mini',
                                    }
                                },
                                '最新'
                            ))
                        }

                        return h(
                            'span',
                            res
                        )
                    }
                },
            ],
            pageModel: {
                page: 1,
                pageSize: 10,
            },
            total: 0,
            clickData2: [
                {
                    label: "推荐",
                    value: "recommend",
                    rule(row) {
						return row.is_recommend === 2;
					}
                },
            ],
            clickData: [
                {
                    label: "推荐",
                    value: "recommend",
                    rule(row) {
						return row.is_recommend === 2;
					}
                },
                {
                    label: "详情",
                    value: "detail",
                    color: '#00CD6A',
                    disabled: this.activeName < 3
                },
                {
                    label: "下线",
                    value: "online",
                    disabled: this.activeName < 3
                },
                {
                    label: "复制",
                    value: "copy",
                    disabled: this.activeName < 3
                },
                {
                    label: "删除",
                    value: "del",
                    color: "red",
                    disabled: this.activeName < 3
                },
            ],
            loading: false
        };
    },
    components: {
        Detail,
        UserDetail,
        Recommend
    },
    methods: {
        clickUser(node) {
            this.$refs.userDetail.fetchList(node.uid)
            
        },
        handleClick(tab, event) {
			this.pageModel.page = 1;
            this.fetchList();

        },
        search() {
            this.pageModel.page = 1;
            this.fetchList();
        },
        fetchList() {
            let recommendType = {}
            if (this.activeName > 2) {
                recommendType = {
                    recommendType: this.activeName == 3 ? 1 : 2
                }
            }

            groupList({
                ...this.pageModel,
				sourceType: this.activeName < 3 ? Number(this.activeName) : 0, //1-官方 2-我的 0-全部
                ...recommendType,
                isRecommend: this.searchModel.isRecommend
            }).then((res) => {
                const { data, total } = res.data;
                data.forEach((d) => {
                    const nowDate = new Date();

                    if (new Date(d.sign_in_offline_time) < nowDate) {
                        d.status = '4'; // 下线
                    } else if (new Date(d.sign_in_end_time) < nowDate) {
                        d.status = '3'; // 结束
                    } else if (new Date(d.sign_in_start_time) < nowDate) {
                        d.status = '2'; // 开始
                    } else if (new Date(d.sign_in_online_time) < nowDate) {
                        d.status = '1'; // 上线
                    } else if (new Date(d.sign_in_online_time) > nowDate) {
                        d.status = '0';
                    }

                    d.sign_in_online_time = formatDate(
                        d.sign_in_online_time,
                        "YYYY-mm-dd"
                    );
                    d.sign_in_offline_time = formatDate(
                        d.sign_in_offline_time,
                        "YYYY-mm-dd"
                    );
                    d.sign_in_start_time = formatDate(
                        d.sign_in_start_time,
                        "YYYY-mm-dd"
                    );
                    d.sign_in_end_time = formatDate(
                        d.sign_in_end_time,
                        "YYYY-mm-dd"
                    );
                });
                this.tableData = data;
                this.loading = false
                this.$forceUpdate()
                this.total = total;
            });
        },
        sortTable(s, e) {
            // console.log(s); // 当前行的被拖拽前的顺序
            // console.log(e); // 当前行的被拖拽后的顺序
            if (this.activeName < 3) return

            const tableCopy = deepClone(this.tableData)

            const sId = tableCopy[s].id
            const eId = tableCopy[e].id

            const currRow = tableCopy.splice(s, 1)[0]
            const trueIndex = tableCopy.findIndex(t => t.id == eId)

            tableCopy.splice(trueIndex + 1, 0, currRow)

            let groupOrder = []
            tableCopy.forEach((t, index) => {
                groupOrder.push(`${t.id},${index + 1}`)
            })
            this.loading = true
            updateGroupOrder({
                groupOrder: groupOrder.join(';'),
                recommendType: this.activeName == 3 ? 1 : 2
            }).then(res => {
                this.tableData = []
                this.$nextTick(() => {
                    this.fetchList()
                })
            })
        },
        clickRight({ row, type }) {
            if (type == "detail" || type == "copy") {
                this.$refs.detail.show("2", row, type);
            }

            if (type == "del") {
                this.$confirm("确认删除吗？", "警告").then((res) => {
                    delGroup({
                        id: row.id,
                    }).then(() => {
                        this.$message.success("删除成功！");
                        this.fetchList();
                    });
                });
            }
            if (type == "online") {
                this.$confirm("确认下线吗？", "警告").then((res) => {
                    saveGroup({
                        id: row.id,
                        sign_in_offline_time: formatDate(new Date()),
                    }).then(() => {
                        this.$message.success("下线成功！");
                        this.fetchList();
                    });
                });
            }

            if (type == 'recommend') {
                this.$refs.recommend.show(row)
            }
        },
        addGroup() {
            this.$refs.detail.show("2", null, "create");
        },
    },
    mounted() {
        this.fetchList();
    },
};
</script>

<style lang="less"></style>
